import { render, staticRenderFns } from "./patientInfo.vue?vue&type=template&id=3e3b241c&scoped=true&"
import script from "./patientInfo.vue?vue&type=script&lang=js&"
export * from "./patientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b241c",
  null
  
)

export default component.exports